import { useQuery } from '@tanstack/react-query';

import { apiFetch } from '@/api/client';
import type {
  GoodsReceipt,
  GoodsReceiptFilters,
  GoodsReceiptSummary,
  Paged,
} from '@core/api/masters';
import { goodsReceiptPath, goodsReceiptsPath } from '@core/api/queryPaths';

export type { GoodsReceipt, GoodsReceiptLine, GoodsReceiptSummary } from '@core/api/masters';

export const goodsReceiptsKey = ['goods-receipt'] as const;

/** The acting branch's deliveries — the branch is in the key, so a switch never shows the last shop's. */
export function useGoodsReceipts(branchId: number | undefined, filters: GoodsReceiptFilters = {}) {
  return useQuery({
    queryKey: [...goodsReceiptsKey, { branchId, ...filters }],
    queryFn: () => apiFetch<Paged<GoodsReceiptSummary>>(goodsReceiptsPath(filters)),
    enabled: branchId !== undefined,
    placeholderData: (previous) => previous,
  });
}

export function useGoodsReceipt(id: number | null) {
  return useQuery({
    queryKey: [...goodsReceiptsKey, 'one', id],
    queryFn: () => apiFetch<GoodsReceipt>(goodsReceiptPath(id ?? 0)),
    enabled: id !== null,
  });
}
